import { Button } from "$components/button/button";
import {
  Card,
  CardBody,
  CardColors,
  CardDetails,
  CardSubtitle,
  CardSummary,
  CardTitle,
} from "$components/card";
import { Box } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

export const HemeHealthCard: FC = () => {
  const color = CardColors.CONSULTATION;

  return (
    <Card color={color} defaultExpanded>
      <CardBody>
        <CardSummary>
          <Box display="flex" flexDirection="column" alignItems="flex-start">
            <CardSubtitle color={color} gutterBottom>
              <FormattedMessage
                id="patient-history.card.hemeHealth.title"
                defaultMessage="Imaging"
              />
            </CardSubtitle>
            <CardTitle>
              <FormattedMessage
                id="patient-history.card.hemeHealth.subtitle"
                defaultMessage="Results"
              />
            </CardTitle>
          </Box>
        </CardSummary>
        <CardDetails>
          <Button
            onClick={() =>
              window.open(
                "https://doctors.hemehealth.io/patient-records?patient_id=c4d32360-0958-4eba-9ac6-ddab645cb9c6",
                "_blank",
                "noreferrer",
              )
            }
          >
            <FormattedMessage
              id="patient-history.card.file.download"
              defaultMessage="View here"
            />
          </Button>
        </CardDetails>
      </CardBody>
    </Card>
  );
};
